import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { FiCheckCircle } from "react-icons/fi";
import { useDispatch } from "react-redux";
import styles from "./VideoKyc.module.scss";
import { setVKYCStep } from "../../redux/slices/userSlice";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function VKYCApproved() {
  const [data, setData] = useState(null);
  const isFetching = useRef(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { transaction_id, vkyc_status, api_response } = location.state || {};

  const transactionID = transaction_id || localStorage.getItem("transaction_id");

  const vkycStatus = vkyc_status || localStorage.getItem("vkyc_status");

  useEffect(() => {
    dispatch(setVKYCStep("VKYC_APPROVED"));

    if (!transactionID || !vkycStatus || isFetching.current) {
      return;
    }

    isFetching.current = true;

    const fetchStatusDetails = async () => {
      handleShowContextualLoader();

      try {
        const { vkycStatusDetailsAPI } = new AfterOnboardAPI();

        const res = await vkycStatusDetailsAPI(transactionID, vkycStatus, api_response);

        setData(res.data);

        if (res?.data?.leadStatus === "Rejected Process") {
          navigate("/video-kyc-rejected", {
            state: {
              transaction_id: transactionID,
              vkyc_status: vkycStatus,
              api_response,
            },
            replace: true,
          });
        }

        // else {
        //   navigate("/", { replace: true });
        // }
      } catch (error) {
        console.error("VKYC status details error:", error);
        isFetching.current = false;
      } finally {
        handlehideContextualLoader();
      }
    };

    fetchStatusDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionID, vkycStatus, dispatch]);

  return (
    <div className="wrapper">
      <main className={styles.page}>
        <section className={styles.content}>
          <div className={`${styles.statusIcon} ${styles.statusIconSuccess}`}>
            <FiCheckCircle size={38} />
          </div>

          <h1 className={styles.title}>Video KYC approved</h1>

          <p className={styles.description}>Great — your identity is verified. Your loan is moving to disbursal.</p>

          <div className={styles.detailsCard}>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Session ID</span>
              <strong className={styles.detailValue}>{data?.vkyc_transaction_id || "-"}</strong>
            </div>

            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Timestamp</span>
              <strong className={styles.detailValue}>{data?.vkyc_initiate_date ? moment(data.vkyc_initiate_date).format("DD-MM-YYYY HH:mm:ss") : "-"}</strong>
            </div>

            <div className={`${styles.detailRow} ${styles.detailRowLast}`}>
              <span className={styles.detailLabel}>Loan amount</span>
              <strong className={styles.loanAmount}>₹{data?.approved_loan_amount || 0}</strong>
            </div>
          </div>
        </section>

        <div className={styles.footer}>
          <button
            type="button"
            className={styles.actionButton}
            onClick={() => {
              dispatch(setVKYCStep(""));
              navigate("/home");
            }}
          >
            Continue to disbursal
          </button>
        </div>
      </main>
    </div>
  );
}
